<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
export default {
  components: { top, bottom },
  name: "home",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: 'BCEIA-学术报告会',
      meta: [
        { 
          name: 'description', 
          content: '学术报告会学术报告会学术报告会' 
        }
      ]
    }
  },
  data() {
    return {
    };
  },
  created() {},
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
  },
  methods: {

  },
};
</script>

<style lang="scss">
</style>